import React from 'react';
import { Button } from 'grommet';

const Placeholder = ({
  title = null,
  message = null,
  button = null
}) => (
  <div className='placeholder'>
    <div className='placeholder__content'>
      {title && (
        <h2 className='placeholder__title'>
          {title}
        </h2>
      )}

      {message && (
        <p className='placeholder__message'>
          {message}
        </p>
      )}

      {button && (
        <Button
          primary
          label={button.label}
          onClick={() => button.action()}
          className='placeholder__button'
        />
      )}
    </div>
  </div>
);

export default Placeholder;
